import React from 'react';
import {useState, useEffect, createContext, useContext, useCallback} from "react";

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';

function Select_UnderlyingProductCode(props){

    const{
        UnderlyingProductCode,
        UnderlyingProductCodeOptions,
        UnderlyingProductCode_Callback,
    } = props;

    function onChange_UnderlyingProductCode(P_UnderlyingProductCode){
        UnderlyingProductCode_Callback(P_UnderlyingProductCode);
    }

    return(
        <Grid item xs={3}>
            <FormControl style={{ width: '100%' }}>
                <InputLabel id="UnderlyingProductCodeLabel">UnderlyingProductCode</InputLabel>
                <Select native='true' value={UnderlyingProductCode} name="UnderlyingProductCode" id="UnderlyingProductCode" labelId="UnderlyingProductCodeLabel" onChange={e => onChange_UnderlyingProductCode(e.target.value)}>
                    {UnderlyingProductCodeOptions}
                </Select>
            </FormControl>
        </Grid>
    )

}

export{
    Select_UnderlyingProductCode,
};